import { useParams, Link } from "react-router-dom";
import {
  Box,
  Heading,
  Text,
  Image,
  SimpleGrid,
  Container,
  Stack,
} from "@chakra-ui/react";
import { ProductsData } from "../../data/products";
import { useTranslation } from "react-i18next";

export default function ProductList() {
  const { category } = useParams();
  const { i18n } = useTranslation();
  const isArabic = i18n.language === "ar";

  const products = ProductsData()[category] || [];

  const colors = {
    pink: "#e10ea5",
    yellow: "#d3c615",
    orangeRed: "#f31f1c",
    teal: "#1da179",
    purple: "#6a4bc4",
  };
  const colorValues = Object.values(colors);
  const getRandomColor = () =>
    colorValues[Math.floor(Math.random() * colorValues.length)];

  const headerText = {
    masterbatch: {
      title: isArabic ? "إضافات الماستر باتش" : "Masterbatch Products",
      subtitle: isArabic
        ? "آكتيف بوليمرز هي شركة متخصصة في صناعة مضافات حبيبات الماستر باتش والمواد المضافة لصناعة البلاستيك."
        : "Active Polymers specializes in the production of additive masterbatch pellets and plastic additives.",
    },
    additives: {
      title: isArabic ? "إضافات الماستر باتش المتخصصة" : "Additive Masterbatches",
      subtitle: isArabic
        ? `آكتيف بوليمرز هي شركة متخصصة في صناعة إضافات الماستر باتش`
        : `Specialized additive masterbatches`,
    },
  };

  const currentHeader = headerText[category] || {
    title: isArabic ? "منتجاتنا" : category?.toUpperCase() || "Products",
    subtitle: isArabic ? "اكتشف منتجاتنا" : "Discover our products",
  };

  return (
    <Box py={10} px={4} bg="gray.50" minH="100vh" dir={isArabic ? "rtl" : "ltr"}>
      {/* HEADER */}
      <Container maxW="6xl" textAlign="center" mb={12}>
        <Heading size="2xl" fontWeight="bold" color="teal.600" mb={4}>
          {currentHeader.title}
        </Heading>
        <Text
          fontSize="lg"
          color="gray.600"
          maxW="3xl"
          mx="auto"
          dangerouslySetInnerHTML={{ __html: currentHeader.subtitle }}
        />
      </Container>

      {/* PRODUCT GRID */}
      <Container maxW="7xl">
        <SimpleGrid columns={{ base: 1, sm: 2, md: 3 }} spacing={8}>
          {products.map((p) => {
            const firstSectionBody = p.sections?.[0]?.body;
            const randomColor = getRandomColor();

            return (
              <Box
                key={p.id}
                as={Link}
                to={`/products/${category}/${p.id}`}
                bg="white"
                borderRadius="xl"
                boxShadow="md"
                overflow="hidden"
                _hover={{ transform: "scale(1.03)", transition: "0.3s" }}
              >
                <Box bg={randomColor} py={3} px={4} textAlign="center">
                <Text
                  fontSize="lg"
                  fontWeight="bold"
                  color="white"
                  lineHeight="1.4"
                >
                  {p.title}
                </Text>
                </Box>

                {p.thumbnail && (
                  <Image
                    src={p.thumbnail}
                    alt={p.title}
                    h={{ base: "200px", md: "220px" }}
                    w="100%"
                    objectFit="cover"
                    loading="lazy"
                  />
                )}

                {firstSectionBody && (
                  <Stack p={6} spacing={3}>
                    <Text
                      fontSize="sm"
                      color="gray.600"
                      noOfLines={2}
                      dangerouslySetInnerHTML={{ __html: firstSectionBody }}
                    />
                  </Stack>
                )}
              </Box>
            );
          })}
        </SimpleGrid>
      </Container>
    </Box>
  );
}
